import type { LeanCustomsDeclarationMessage } from "../services/leancustomsService";

export function pickMessageDate(m: LeanCustomsDeclarationMessage): string | undefined {
  return (
    m.created_at ||
    (m as { received_at?: string }).received_at ||
    (m as { inserted_at?: string }).inserted_at ||
    (m as { updated_at?: string }).updated_at
  );
}

export function pickMessageKind(m: LeanCustomsDeclarationMessage): string {
  const v =
    (m as { message_type?: string }).message_type ||
    (m as { type_code?: string }).type_code ||
    (m as { kind?: string }).kind ||
    (m as { category?: string }).category ||
    m.type;
  return typeof v === "string" && v.length > 0 ? v : "—";
}

export function pickMessageBody(m: LeanCustomsDeclarationMessage): string {
  const candidates = [
    (m as { body?: string }).body,
    (m as { content?: string }).content,
    (m as { text?: string }).text,
    (m as { message?: string }).message,
    (m as { description?: string }).description,
    (m as { subject?: string }).subject,
    (m as { summary?: string }).summary,
    (m as { title?: string }).title,
  ];
  for (const c of candidates) {
    if (typeof c === "string" && c.trim().length > 0) return c.trim();
  }
  return "";
}

export function sortMessagesNewestFirst(
  messages: LeanCustomsDeclarationMessage[]
): LeanCustomsDeclarationMessage[] {
  return [...messages].sort((a, b) => {
    const da = pickMessageDate(a);
    const db = pickMessageDate(b);
    if (!da && !db) return 0;
    if (!da) return 1;
    if (!db) return -1;
    return new Date(db).getTime() - new Date(da).getTime();
  });
}
